import { DataUtilService } from 'src/app/_services/data-util.service';
import { AuthHeader } from './../_models/headers';

import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestService {
  public iData=new BehaviorSubject<any>(undefined);
  aHeader = undefined
  constructor(private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService) {this.aHeader = new AuthHeader(tss)}


  getIData(countryId:number) {
    return this.http.get<any>(`${environment.apiUrl}/home/getidata/${countryId}`,this.aHeader.openJsonHeaders).pipe(
      map(
        data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
        this.iData.next(myData)
      }
      return myData
    }))
  }

  getIDataDefault() {
    return this.http.get<any>(`${environment.apiUrl}/home/getidatadefault`,this.aHeader.openJsonHeaders).pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }
      return myData
    }))
  }
}
